import React, { PropsWithChildren, createContext, useContext, useEffect, useState } from 'react';
import { LOCALES } from '../config/locales';

interface PageLocaleContextValue {
  pageLocale: LOCALES | undefined;
  setPageLocale: (locale: LOCALES) => void;
}

const PageLocaleContext = createContext<PageLocaleContextValue | null>(null);

export const PageLocaleProvider = ({ children }: PropsWithChildren) => {
  const [pageLocale, setPageLocale] = useState<LOCALES | undefined>();

  return (
    <PageLocaleContext.Provider value={{ pageLocale, setPageLocale }}>
      {children}
    </PageLocaleContext.Provider>
  );
};

// Its only users (the blog list, the post editor and their language picker) render inside the Blog page template, which
// always mounts PageLocaleProvider (`withPageLocaleContext`).
export const usePageLocaleContext = () => useContext(PageLocaleContext) as PageLocaleContextValue;
